import React, { useEffect, useMemo } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import InputAutoDetect from 'apps/auth/components/form/InputAutoDetect';
import { getSortFields } from 'apps/auth/components/form-multi/utils';
import { checkValueAndError, checkResidencyAndError, checkFields, setPassportInput } from 'apps/auth/services/kycService';

const KycFields = ({
    title,
    subtitle,
    caption,
    fields,
    formName,
    toCountry,
    onClickHandler,
    eventName,
    inputPassportComment = '',
    inputPassportPlaceholder = '',
}) => {
    const disabled = useMemo(() => {
        if (fields && fields.length > 0) {
            return !(fields.every(checkValueAndError) || fields.some(checkResidencyAndError));
        }
    }, [fields]);
    useEffect(() => {
        if (eventName) {
            amplitude.getInstance().logEvent(eventName);
        }
    }, [eventName]);

    const updatedFields = setPassportInput(checkFields(fields), inputPassportComment, inputPassportPlaceholder);
    return (
        <>
            <HeaderPanel subtitle={subtitle} title={title} />
            <fieldset>
                {getSortFields(updatedFields).map((field) => {
                    return (
                        <fieldset key={field.name}>
                            <InputAutoDetect isClearErrorOnFocus formName={formName} defaultCountry={toCountry?.code} field={field} />
                        </fieldset>
                    );
                })}
            </fieldset>
            <FixedBottomPanel isRightAligned>
                <Button type="button" raised={true} disabled={disabled} onClick={onClickHandler} caption={caption} />
            </FixedBottomPanel>
        </>
    );
};
KycFields.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    caption: PropTypes.string,
    toCountry: PropTypes.string,
    formName: PropTypes.string,
    onClickHandler: PropTypes.func,
    fields: PropTypes.array,
    eventName: PropTypes.string,
    inputPassportPlaceholder: PropTypes.string,
    inputPassportComment: PropTypes.string,
};

export default KycFields;
